import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Chapter from "@/pages/home/components/Chapter";
import SiteNav from "@/pages/home/components/SiteNav";
import AboutPanel from "@/pages/home/components/AboutPanel";
import Manifesto from "@/pages/home/components/Manifesto";
import ServicesPanel from "@/pages/home/components/ServicesPanel";
import NumbersBand from "@/pages/home/components/NumbersBand";
import ProcessPanel from "@/pages/home/components/ProcessPanel";
import Faq from "@/pages/home/components/Faq";
import Reviews from "@/pages/home/components/Reviews";
import ContactPanel from "@/pages/home/components/ContactPanel";
import SiteFooter from "@/pages/home/components/SiteFooter";
import { initPanels } from "@/pages/home/lib/film";

export default function Home() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const lang = i18n.language === "es" ? "es" : "en";
    document.documentElement.lang = lang;
    document.title = t("seo.title");

    const setMeta = (selector: string, attr: string, value: string) => {
      const el = document.head.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };
    setMeta('meta[name="description"]', "content", t("seo.desc"));
    setMeta('meta[property="og:title"]', "content", t("seo.title"));
    setMeta('meta[property="og:description"]', "content", t("seo.desc"));
    setMeta('meta[name="twitter:title"]', "content", t("seo.title"));
    setMeta('meta[name="twitter:description"]', "content", t("seo.desc"));
  }, [i18n.language, t]);

  useEffect(() => {
    const t = setTimeout(() => initPanels(document), 60);
    return () => clearTimeout(t);
  }, [i18n.language]);

  return (
    <div style={{ background: "var(--bg)", color: "var(--text)" }}>
      <SiteNav />
      <main key={i18n.language}>
        <Chapter />
        <Manifesto />
        <AboutPanel />
        <ServicesPanel />
        <NumbersBand />
        <ProcessPanel />
        <Reviews />
        <Faq />
        <ContactPanel />
      </main>
      <SiteFooter />
    </div>
  );
}